import type { ComponentProps } from 'react'

import { type InputProps, InputWrapper } from '../inputWrapper/InputWrapper'
import { createInternalWrapperPropsAndId } from '../utility'
import { RawMultiSelect } from './RawMultiSelect'

type Props<T> = ComponentProps<typeof RawMultiSelect<T>> & InputProps

export const MultiSelect = <T,>({ wrapperProps, ...fieldProps }: Props<T>) => {
  const { internalWrapperProps, id } = createInternalWrapperPropsAndId({
    wrapperProps,
    id: fieldProps.id,
  })

  return (
    <InputWrapper {...internalWrapperProps}>
      <RawMultiSelect {...fieldProps} id={id} />
    </InputWrapper>
  )
}
